import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { _ } from '/@/locale';
import { HELP_CENTER_PAGE_BG } from './constants';

type HelpCenterHomeSearchFieldProps = {
    value: string;
    onChange: (value: string) => void;
    isSearching: boolean;
    onClear: () => void;
};

export function HelpCenterHomeSearchField({ value, onChange, isSearching, onClear }: HelpCenterHomeSearchFieldProps) {
    return (
        <TextField
            label={_('Buscar')}
            placeholder={isSearching ? undefined : _('Escribí tu consulta')}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            InputProps={{
                startAdornment: (
                    <InputAdornment position='start'>
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: isSearching ? (
                    <InputAdornment position='end'>
                        <IconButton
                            type='button'
                            aria-label={_('Limpiar búsqueda')}
                            onClick={onClear}
                            edge='end'
                            size='small'
                            sx={{
                                bgcolor: HELP_CENTER_PAGE_BG,
                                borderRadius: '100px',
                                p: 0.5,
                                '&:hover': { bgcolor: HELP_CENTER_PAGE_BG },
                            }}
                        >
                            <CloseIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                    </InputAdornment>
                ) : undefined,
            }}
            sx={{
                width: '100%',
                background: 'white',
            }}
            fullWidth
        />
    );
}
